import { atom } from 'recoil';

export const searchSortState = atom<number>({
  key: 'searchSort',
  default: 3,
});
